import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MaterialModule } from "../../module/material.module";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: "rfc-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MaterialModule
  ],
  // providers: [
  //   SnackbarService,
  //   {
  //       provide: MAT_SNACK_BAR_DATA,
  //       useValue: {},
  //   },
  // ],
})
export class SnackbarComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data,
    public snackBarRef: MatSnackBarRef<SnackbarComponent>
  ) {}

  ngOnInit() {}
}
